module.exports = __webpack_public_path__ + "img/gift-popup-ok.899fb8f8.svg";